<template>
    <div>
        <div class="container contenido_principal">
            <div class="container text-center mt-5">
                <h1 class="bold300" style="/*font-size:2rem;*/ font-weight:500;">Marco jurídico Federal</h1>
            </div>
            <!-- ===Apartado de las cards=== -->
            <div class="seccion_cardsOpciones my-2">
                <div class="row px-1 d-flex align-items-center justify-content-between">
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <router-link :to="{name:'federal-leyes'}" class="nav-link">
                            <div class="card mb-3 p-1" >
                                <div class="row no-gutters">
                                    <!---Imagen de la card-->
                                    <div class="col-md-4 p-2 text-center justify-content-center" >
                                        <i class='fa fa-balance-scale icono_card'></i>
                                    </div>
                                    <!---Texto de la card-->
                                    <div class=" col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-4">Leyes</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <router-link :to="{name:'federal-decretos'}" class="nav-link">
                            <div class="card mb-3 p-1" id="seleccionado">
                                <div class="row no-gutters">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="fas fa-pen-fancy icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-4">Decretos</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="row px-1 d-flex align-items-center justify-content-between">
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <router-link :to="{name:'federal-acuerdos'}" class="nav-link">
                            <div class="card mb-3 p-1" >
                                <div class="row no-gutters">
                                    <!---Imagen de la card-->
                                    <div class="col-md-4 p-2 text-center justify-content-center" >
                                        <i class="far fa-handshake icono_card"></i>
                                    </div>
                                    <!---Texto de la card-->
                                    <div class=" col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-4">Acuerdos</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <router-link :to="{name:'federal-reglamentos'}" class="nav-link">
                            <div class="card mb-3 p-1" id="seleccionado">
                                <div class="row no-gutters">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="fas fa-tasks icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-4">Reglamentos</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="row px-1 d-flex align-items-center justify-content-between">
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <router-link :to="{name:'federal-reglas'}" class="nav-link">
                            <div class="card mb-3 p-1" >
                                <div class="row no-gutters">
                                    <!---Imagen de la card-->
                                    <div class="col-md-4 p-2 text-center justify-content-center" >
                                        <i class="fas fa-tasks icono_card"></i>
                                    </div>
                                    <!---Texto de la card-->
                                    <div class=" col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-4">Reglas</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <router-link :to="{name:'federal-lineamientos'}" class="nav-link">
                            <div class="card mb-3 p-1" id="seleccionado">
                                <div class="row no-gutters">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="far fa-file-alt icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-4">Lineamientos</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="row px-1 d-flex align-items-center justify-content-between">
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <!-- <a href="http://www.haciendachiapas.gob.mx/informacion-interes/armonizacion-contable/doctos-aprobados.asp" target="_blank" class="nav-link"> -->
                            <router-link :to="{name: 'documentosAprobadosConac'}">
                            <div class="card mb-3 p-1" id="seleccionado">
                                <div class="row no-gutters">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="fas fa-book-open icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-4">Disposiciones CONAC</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </router-link>
                        <!-- </a> -->
                    </div>
                </div>
                <!-- LEYENDA -->
                <div class="text-leyenda">
                    <h4>La edición de los ordenamientos jurídicos en medios electrónicos no representa una versión oficial, ya que de acuerdo al artículo 3o. del Código Civil Federal y artículos 1o., 2o., 3o., 4o. y 8o. de la Ley del Diario Oficial de la Federación y Gacetas Gubernamentales, la única publicación que da validez jurídica a una norma es el propio Diario Oficial de la Federación, la Gaceta Oficial del Distrito Federal o los periódicos oficiales estatales.</h4>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    methods:{

    }
}
</script>
